import Sidebar from "../components/Sidebar";
import ProductSearch from "./UtmVisualization/ProductSearch";
import "react-datepicker/dist/react-datepicker.css";
import "./WelcomeScreen.css"; // Import custom CSS for styling
import { toast, ToastContainer } from "react-toastify"; // Import toast
import "react-toastify/dist/ReactToastify.css"; // Import styles
import ProductClick from "./UtmVisualization/productClick";
import ProductNav from "./UtmVisualization/productNav";
import SessionInfo from "./UtmVisualization/SessionInfo";
import UtmCustomerSupport from "./UtmVisualization/CustomerSupport";
import BestDealShow from "./UtmVisualization/BestDealShow";
import RedirectionShow from "./UtmVisualization/RedirectionView";
import CartInformation from "./UtmVisualization/CartInfomation";

const WelcomeScreen = () => {

  return (
    <div className="dashboard-content">
      <Sidebar />
      <div className="main">
        <div className="heading-excel-form">
          <div className="welcome-heading">
            <div className="left-welcome">
              <img
                src="/static/media/logo.1c08c1e01e0bf9677c66.png"
                alt=""
                className="logo-welcome"
              />
            </div>
            <div className="right-welcome">
              <span className="firstwelcome">
                Welcome To <span className="thirdwelcome">Pikeazy</span>
              </span>
            </div>
          </div>
        </div>

        {/* Product search, Product Click, search count */}
        <div className="responsive-grid">
          <div className="grid-item">
            <ProductSearch />
          </div>
          <div className="grid-item">
            <ProductClick />
          </div>
          <div className="grid-item">
            <ProductNav />
          </div>
          <div className="grid-item">
            <SessionInfo />
          </div>
          <div className="grid-item">
            <UtmCustomerSupport />
          </div>
          <div className="grid-item">
            <BestDealShow />
          </div>
          <div className="grid-item">
            <RedirectionShow />
          </div>
          <div className="grid-item">
            <CartInformation />
          </div>
        </div>
      </div>
      <ToastContainer />
    </div>
  );
};

export default WelcomeScreen;
